import { Box, Stack, Typography } from '@mui/material';
import Order from './Order.jsx';

const OrderList = (props) => {
  const { orders } = props;
  return (
    <Box sx={{ width: '48vw', padding: 2 }} {...props}>
      <Typography component={'span'} variant="h4">
        Commandes
      </Typography>
      <Box sx={{ width: '100%' }}>
        {orders?.length > 0 &&
          orders?.map((order) => {
            return (
              <Stack key={order?._id} spacing={1}>
                <Order order={order} />
              </Stack>
            );
          })}
      </Box>
    </Box>
  );
};

export default OrderList;
